<div class="actions">
  <ng-content></ng-content>
</div>
